document.documentElement.classList.remove('no-js');

const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

function showToast(message) {
  const toast = $('[data-cart-toast]');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('is-visible');
  clearTimeout(window.__jwToastTimer);
  window.__jwToastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2500);
}

function updateCartCount(count) {
  $$('[data-cart-count]').forEach((el) => {
    el.textContent = count;
    el.hidden = count < 1;
  });
}

async function refreshCartCount() {
  try {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    const cart = await response.json();
    updateCartCount(cart.item_count);
    return cart;
  } catch (_) {
    return null;
  }
}

function initMobileMenu() {
  const button = $('[data-menu-toggle]');
  const menu = $('[data-mobile-menu]');
  if (!button || !menu) return;
  button.addEventListener('click', () => {
    const open = menu.classList.toggle('is-open');
    button.setAttribute('aria-expanded', String(open));
  });
}

function initQuantity() {
  $$('[data-qty]').forEach((wrap) => {
    const input = $('input[type="number"]', wrap);
    if (!input) return;
    $$('button', wrap).forEach((button) => {
      button.addEventListener('click', () => {
        const step = Number(button.dataset.step || 0);
        const min = Number(input.min || 1);
        input.value = Math.max(min, Number(input.value || min) + step);
      });
    });
  });
}

function initProductGallery() {
  $$('[data-product-gallery]').forEach((gallery) => {
    const main = $('.jw-product__main img', gallery);
    $$('[data-thumb]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.style.opacity = '0';
        setTimeout(() => {
          main.src = thumb.dataset.image;
          main.srcset = '';
          main.alt = thumb.dataset.alt || '';
          main.style.opacity = '1';
        }, 140);
        $$('[data-thumb]', gallery).forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });
}

function initVariantForms() {
  $$('.jw-product-form').forEach((form) => {
    const price = $('[data-price]', form.closest('[data-product-section]') || document);
    const compare = $('[data-compare-price]', form.closest('[data-product-section]') || document);
    $$('input[name="id"]', form).forEach((input) => {
      input.addEventListener('change', () => {
        const variant = JSON.parse(input.dataset.variant || '{}');
        if (price && variant.price_text) price.textContent = variant.price_text;
        if (compare) {
          compare.textContent = variant.compare_at_price_text || '';
          compare.hidden = !variant.compare_at_price_text;
        }
      });
    });
  });
}

function initAjaxCart() {
  $$('.jw-product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = $('[type="submit"]', form);
      const original = submit ? submit.textContent : '';
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Adding…';
      }
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Could not add this item.');
        }
        const addedItem = await response.json().catch(() => null);
        const cart = await refreshCartCount();
        document.dispatchEvent(
          new CustomEvent('product:added', {
            detail: {
              item: addedItem,
              cart
            }
          })
        );
      } catch (error) {
        showToast(error.message || 'Something went wrong');
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.textContent = original;
        }
      }
    });
  });
}

const revealController = (() => {
  let observer = null;
  const initialized = new WeakSet();
  const visible = new WeakSet();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const isMobile = () => window.matchMedia('(max-width: 860px)').matches;

  const getViewportHeight = () =>
    window.innerHeight || document.documentElement.clientHeight || 800;

  const reveal = (item, immediate = false) => {
    if (!item || visible.has(item)) return;

    visible.add(item);
    observer?.unobserve(item);
    item.dataset.jwRevealVisible = 'true';
    item.style.visibility = 'visible';

    if (immediate || reduceMotion) {
      item.style.transition = 'none';
      item.style.opacity = '1';
      item.style.transform = 'translate3d(0, 0, 0)';
      item.style.willChange = 'auto';
      return;
    }

    requestAnimationFrame(() => {
      item.style.opacity = '1';
      item.style.transform = 'translate3d(0, 0, 0)';

      window.setTimeout(() => {
        item.style.willChange = 'auto';
      }, isMobile() ? 520 : 680);
    });
  };

  const isAlreadyInView = (item) => {
    const rect = item.getBoundingClientRect();
    const viewportHeight = getViewportHeight();
    return rect.bottom > 0 && rect.top < viewportHeight * 0.9;
  };

  const ensureObserver = () => {
    if (observer || reduceMotion || !('IntersectionObserver' in window)) return;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            reveal(entry.target, false);
          }
        });
      },
      {
        threshold: 0.01,
        rootMargin: isMobile() ? '0px 0px -8% 0px' : '0px 0px -10% 0px'
      }
    );
  };

  const prepare = (item) => {
    if (!item || initialized.has(item)) return;

    initialized.add(item);
    item.dataset.jwRevealInitialized = 'true';
    item.style.visibility = 'visible';

    if (
      reduceMotion ||
      !('IntersectionObserver' in window) ||
      isAlreadyInView(item)
    ) {
      reveal(item, true);
      return;
    }

    const duration = isMobile() ? 500 : 640;
    const distance = isMobile() ? 18 : 26;

    item.style.opacity = '0';
    item.style.transform = `translate3d(0, ${distance}px, 0)`;
    item.style.transition =
      `opacity ${duration}ms cubic-bezier(0.22, 1, 0.36, 1), ` +
      `transform ${duration}ms cubic-bezier(0.22, 1, 0.36, 1)`;
    item.style.willChange = 'opacity, transform';

    ensureObserver();
    observer?.observe(item);
  };

  const init = (root = document) => {
    $$('[data-reveal]', root).forEach(prepare);
  };

  const revealWithin = (root, immediate = true) => {
    if (!root) return;

    const items = [
      ...(root.matches?.('[data-reveal]') ? [root] : []),
      ...$$('[data-reveal]', root)
    ];

    items.forEach((item) => {
      if (!initialized.has(item)) prepare(item);
      reveal(item, immediate);
    });
  };

  const revealVisibleNow = () => {
    $$('[data-reveal][data-jw-reveal-initialized="true"]').forEach((item) => {
      if (!visible.has(item) && isAlreadyInView(item)) {
        reveal(item, false);
      }
    });
  };

  let queued = false;
  const queueVisibleCheck = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      revealVisibleNow();
    });
  };

  window.addEventListener('scroll', queueVisibleCheck, { passive: true });
  window.addEventListener('resize', queueVisibleCheck, { passive: true });
  window.addEventListener('pageshow', queueVisibleCheck, { passive: true });

  return {
    init,
    revealWithin,
    reveal,
    refresh: queueVisibleCheck
  };
})();

window.JawzReveal = revealController;

function startRevealAnimations() {
  revealController.init(document);
}

function revealHashTargetFromLink(link) {
  if (!(link instanceof HTMLAnchorElement)) return;

  let url;

  try {
    url = new URL(link.href, window.location.href);
  } catch (_) {
    return;
  }

  if (
    url.origin !== window.location.origin ||
    url.pathname.replace(/\/+$/, '') !== window.location.pathname.replace(/\/+$/, '') ||
    !url.hash
  ) {
    return;
  }

  let id = '';

  try {
    id = decodeURIComponent(url.hash.slice(1));
  } catch (_) {
    id = url.hash.slice(1);
  }

  const target = document.getElementById(id);
  if (!target) return;

  const section = target.matches('section')
    ? target
    : target.closest('section') || target.nextElementSibling || target;

  revealController.revealWithin(section, true);
}

document.addEventListener(
  'pointerdown',
  (event) => {
    const link = event.target.closest?.('a[href*="#"]');
    revealHashTargetFromLink(link);
  },
  true
);

document.addEventListener(
  'click',
  (event) => {
    const link = event.target.closest?.('a[href*="#"]');
    revealHashTargetFromLink(link);
  },
  true
);

window.addEventListener('hashchange', () => {
  const hash = window.location.hash;
  if (!hash) return;

  let id = '';

  try {
    id = decodeURIComponent(hash.slice(1));
  } catch (_) {
    id = hash.slice(1);
  }

  const target = document.getElementById(id);
  if (!target) return;

  const section = target.matches('section')
    ? target
    : target.closest('section') || target.nextElementSibling || target;

  revealController.revealWithin(section, true);
});

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initQuantity();
  initProductGallery();
  initVariantForms();
  initAjaxCart();
  startRevealAnimations();
  refreshCartCount();
});

window.addEventListener('pageshow', () => {
  revealController.init(document);
  revealController.refresh();
});

document.addEventListener('jw:preloader-complete', () => {
  revealController.init(document);
  revealController.refresh();
});

document.addEventListener('shopify:section:load', (event) => {
  revealController.init(event.target || document);
});
